export default __webpack_public_path__ + "images/bellImg.d0378aba.png";